import 'react-table/react-table.css'
import '../../../_components/table/table.styles.css'

import { Button } from '@helvetia/components/Button'
import LinkText from '@helvetia/components/LinkText'
import { MatchMedia } from '@helvetia/components/MatchMedia'
import Spinner from '@helvetia/components/Spinner'
import Text from '@helvetia/components/Text'
import dayjs from 'dayjs'
import numeral from 'numeral'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ReactTable from 'react-table'

import { LifecycleView } from '../../../_components/ConnectComponent'
import EmailSVG from '../../../_components/icons/email.svg'
import { ClickableIcon } from '../../../_components/icons/icons'
import DeleteSVG from '../../../_components/icons/papelera.svg'
import PdfSVG from '../../../_components/icons/pdf.svg'
import { Modal } from '../../../_components/Modal'
import { offerDocumentViewMapper } from '../OfferView.mapper'
import { OfferTablePresenter } from './OfferTable.presenter'

export interface View extends LifecycleView {
  showLoading: () => void
  hideLoading: () => void
}

interface Props {
  presenter: OfferTablePresenter
}

interface State {
  isLoading: boolean
  isModalOpen: boolean
  page: number
  pages: number
  pageSize: number
  offerList: any[]
}

export class OfferTableRaw
  extends React.Component<Props & RouteComponentProps & WithNamespaces, State>
  implements View {
  private presenter: OfferTablePresenter

  constructor(props) {
    super(props)

    this.presenter = props.presenter
    this.presenter.initialize(this)

    this.state = {
      isLoading: false,
      isModalOpen: false,
      page: 0,
      pages: 1,
      pageSize: 20,
      offerList: [],
    }
  }

  setInitialValues = (offerList, pagination) => {
    this.setState({
      offerList: offerList.map(offerDocumentViewMapper),
      page: pagination.currentPage,
      pages: pagination.totalPages,
      pageSize: pagination.itemsPerPage,
    })
  }

  getOffers = () => {
    this.presenter
      .getOffers(this.state.page, this.state.pageSize)
      .then(response => {
        this.setState(
          {
            offerList: response.notExpiredOffers.map(offerDocumentViewMapper),
            page: response.pagination.currentPage,
            pages: response.pagination.totalPages,
            pageSize: response.pagination.itemsPerPage,
          },
          this.hideLoading,
        )
      })
  }

  onPageChange = page => {
    this.setState({ isLoading: true, page }, this.getOffers)
  }

  onPageSizeChange = (pageSize: number) => {
    this.setState({ isLoading: true, pageSize }, this.getOffers)
  }

  onViewOffer = (offerId: string) => {
    this.presenter.goToViewOffer(offerId)
  }

  onContract = (offerId: string) => {
    this.presenter.onContract(offerId)
  }

  onDiscard = (offerId: string) => this.presenter.onDiscardOffer(offerId)

  showLoading = () => this.setState({ isLoading: true })

  hideLoading = () => this.setState({ isLoading: false })

  showModal = () => this.setState({ isModalOpen: true })

  hideModal = () => this.setState({ isModalOpen: false })

  render() {
    const { isLoading, offerList, isModalOpen } = this.state
    const { t } = this.props

    if (isLoading) return <Spinner size="xl" />

    if (isModalOpen)
      return (
        <Modal
          buttonText={t('buttons.accept')}
          onClose={this.hideModal}
          title={
            <>
              <MatchMedia onlyMobile>
                <Text size="sBold">{t('modal.email.title')}</Text>
              </MatchMedia>
              <MatchMedia tablet>
                <Text size="sBold">{t('modal.email.title')}</Text>
              </MatchMedia>
            </>
          }
        >
          <Text size="m" as="p" color="black">
            {t('modal.email.send')}
          </Text>
        </Modal>
      )

    return (
      <ReactTable
        manual
        resizable={false}
        filterable={true}
        showPagination={true}
        loading={false}
        data={offerList}
        columns={this.columns()}
        onPageChange={page => this.onPageChange(page)}
        onPageSizeChange={pageSize => this.onPageSizeChange(pageSize)}
        page={this.state.page}
        pageSize={this.state.pageSize}
        pages={this.state.pages}
        previousText={t('pagination.previous')}
        nextText={t('pagination.next')}
        pageText={t('pagination.pages')}
        ofText={t('pagination.ofTotal')}
        rowsText={t('pagination.rowsSelectorText')}
      />
    )
  }

  columns() {
    const { t } = this.props
    const { offerList } = this.state

    if (offerList && offerList.length < 1) {
      return []
    }

    return [
      {
        Header: () => <span>ID</span>,
        accessor: 'offerNumber',
        filterable: false,
        width: 80,
        Cell: row => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            <LinkText
              onClick={() => this.onViewOffer(row.original.id)}
              text={row.original.offerNumber}
              color="primary"
            />
          </div>
        ),
      },
      {
        Header: () => t('table.validity'),
        accessor: 'creationOfferDate',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 130,
        Cell: row => (
          <div>
            {dayjs(row.original.creationOfferDate)
              .add(3, 'month')
              .format('DD.MM.YYYY')}
            <br />
            {`${dayjs(row.original.creationOfferDate)
              .add(3, 'month')
              .diff(dayjs(new Date()), 'day', false)}${t('table.daysLeft')}`}
            <br />
          </div>
        ),
      },
      {
        Header: () => t('table.price'),
        accessor: 'price',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 130,
        Cell: props => numeral(props.value).format('0,0.00'),
      },
      {
        Header: () => t('table.customer'),
        accessor: 'company',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 275,
        Cell: row => (
          <div>
            {row.original.company}
            <br />
            {row.original.firstName + ' ' + row.original.lastName}
          </div>
        ),
      },

      {
        Header: () => t('table.contact'),
        accessor: 'email',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 300,
        Cell: row => (
          <div>
            {row.original.email}
            <br />
            {row.original.phone && row.original.phone.trim().length > 3
              ? row.original.phone
              : ''}
          </div>
        ),
      },

      {
        Header: () => t('table.actions'),
        id: 'actionButtons',
        filterable: false,
        width: 400,
        accessor: d => d,
        Cell: row => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'baseline',
              alignContent: 'center',
              marginLeft: '15px',
            }}
          >
            {
              <Button
                whitePrimary
                compact
                onClick={() => {
                  this.onContract(row.original.id)
                }}
              >
                {t('table.contract')}
              </Button>
            }
            <ClickableIcon
              src={PdfSVG}
              onClick={() =>
                this.presenter.onDownloadOfferPDF(
                  row.original.id,
                  row.original.offerNumber,
                )
              }
              marginRight="xxs"
              marginLeft="xxxs"
            />
            <ClickableIcon
              src={EmailSVG}
              onClick={() =>
                this.presenter.onSendOfferToCustomer(row.original.id)
              }
              marginRight="xxs"
            />
            <ClickableIcon
              src={DeleteSVG}
              onClick={() => this.onDiscard(row.original.id)}
            />
          </div>
        ),
      },
      /* Filter: ({ onChange }) => (
        <select
          onChange={event => {
            onChange(event.target.value)
            this.props.onRiskTypeSelectorChange(Number(event.target.value))
            this.setState({ isInitialState: false })
          }}
          style={{ width: '100%' }}
          value={
            this.props.riskFilters && this.props.riskFilters.riskTypeId
              ? this.props.riskFilters.riskTypeId
              : 'all'
          }
        >
          {this.printOptionList(this.state.riskTypeList, t)}
        </select>
      ), */
    ]
  }
}

export const OfferTableView = withNamespaces()(withRouter(OfferTableRaw))
